import { motion } from "framer-motion";

/**
 * Line-by-line masked reveal: each line lives in an overflow-hidden container
 * and rises up from below. Designed as the signature on-load moment.
 */
export const MaskedHeadline = ({ lines, delay = 0, className = "" }) => (
  <h1 className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.12em]">
        <motion.span
          initial={{ y: "110%", opacity: 0 }}
          animate={{ y: "0%", opacity: 1 }}
          transition={{
            delay: delay + i * 0.14,
            duration: 1.05,
            ease: [0.22, 1, 0.36, 1],
          }}
          className="block will-change-transform"
        >
          {line}
        </motion.span>
      </span>
    ))}
  </h1>
);
